import {NgOptimizedImage} from "@angular/common";
import {Component, inject, LOCALE_ID, signal} from "@angular/core";
import {map, type Observable, shareReplay, zip} from "rxjs";
import type {SafeValueResourceRef} from "../../helpers/ResourceHelpers";
import {rxSafeResource} from "../../helpers/ResourceHelpers";
import {Header} from "../../layout/header/header";
import {ReferenceKind} from "../../models/Reference/Reference";
import {ReferenceLinkKind} from "../../models/Reference/ReferenceLink";
import type {References} from "../../models/Reference/References";
import {SafeHtmlPipe} from "../../pipes/safe-html-pipe";
import {ReferencesApi} from "../../services/api/references-api";

@Component({
  selector: "app-projects-list",
  templateUrl: "./projects-list.html",
  styleUrl: "./projects-list.scss",
  imports: [
    Header,
    SafeHtmlPipe,
    NgOptimizedImage,
  ],
})
export default class ProjectsList {
  protected readonly locale = inject(LOCALE_ID);

  private readonly currentOffset = signal(0);
  protected readonly references: SafeValueResourceRef<References>;

  public constructor() {
    const referencesApi = inject(ReferencesApi);
    let lastProjects: Observable<References> | undefined;
    this.references = rxSafeResource({
      params: () => ({offset: this.currentOffset()}),
      stream: ({params: {offset}}) => {
        const loaded = referencesApi.getAllReferences({offset}).pipe(shareReplay(1));
        lastProjects = offset === 0 || !lastProjects ? loaded : zip([lastProjects, loaded]).pipe(
          map(([existing, newLoaded]) => ({
            entries: existing.entries.concat(newLoaded.entries),
            total: newLoaded.total,
          })),
        );
        return lastProjects;
      },
      defaultValue: {entries: [], total: 0},
    });
  }

  protected loadMore(currentLength: number): void {
    this.currentOffset.set(currentLength);
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  protected readonly ReferenceKind = ReferenceKind;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  protected readonly ReferenceLinkKind = ReferenceLinkKind;
}
